import { Component, Input, OnInit } from '@angular/core';
import { PeticionesHttpBackEndService } from '../../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../../@core/utils/utilidades.service';

@Component({
  selector: 'ngx-status-card',
  styleUrls: ['./status-card.component.scss'],
  template: `
    <nb-card (click)="on = !on" [ngClass]="{'off': !on}">
      <div class="icon-container">
        <div class="icon {{ type }}">
          <ng-content></ng-content>
        </div>
      </div>

      <div class="details">
        <div class="title">{{ on ? (resultado | number : '1.0-2') : '' }}</div>
        <div class="status">{{ title }}</div>
      </div>
    </nb-card>
  `,
})
export class StatusCardComponent implements OnInit {

  @Input() title: string;
  @Input() type: string;
  @Input() on = true;
  resulActMes:any;
  resultado:any = "";

  constructor(private _http : PeticionesHttpBackEndService,public utilidades: UtilidadesService) {}

  ngOnInit(){
  
    if(this.title == "Actividades del mes"){
      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.actividadesMes[0].NumActividadesMes;
        },
        error => {
        //  this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );


      
    }else if(this.title == "Actividades del año"){
      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.actividadesAnio[0].NumActividadesAnio;
        },
        error => {
          //this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );

    }else if(this.title == "Participantes del mes"){
      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.apuntadosMes[0].NumApuntadosMes;
        },
        error => {
        //  this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );
      
    }else if(this.title == "Participantes del año"){
      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.apuntadosAnio[0].NumApuntadosAnio;
        },
        error => {
         // this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );
      
    }else if(this.title == "Balance económico mes"){
      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.balancesMes[0].CantidadMes;
        },
        error => {
        //  this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );
      
    }else if(this.title == "Balance económico año"){

      this._http.getGenerico("v1/actividadesMes").subscribe(
        result => {
          this.resulActMes = result;
          this.resultado = this.resulActMes.balancesAnios[0].CantidadAnio;
        },
        error => {
        //  this.utilidades.notificationWarning("Info",""+"No se han podido cargar los datos"+"","top-left");
        }
      );
      
    }
  }
}
